import { withForceKeycloak } from 'probonio-shared-ui/utils/bikeleasingUrl';

import { getCurrentCountry } from '~/utils/countryUtils';
import { UrlSchema } from '~/utils/urlUtils';

export const OAUTH2_ISSUER_URI = import.meta.env.VITE_OAUTH2_ISSUER_URI;
export const OAUTH2_CLIENT_ID = import.meta.env.VITE_OAUTH2_CLIENT_ID;
export const OAUTH2_SCOPES = import.meta.env.VITE_OAUTH2_SCOPES;

export const SSO_PROVIDERS: string[] = (import.meta.env.VITE_SSO_PROVIDERS ?? '')
  .split(',')
  .map((provider: string) => provider.trim())
  .filter(Boolean);

export const ACCOUNT_SERVICE_URL = import.meta.env.VITE_ACCOUNT_SERVICE_URL;
export const APP_API_URL = import.meta.env.VITE_APP_API_URL;
export const EMAIL_CONSENT_URL = import.meta.env.VITE_EMAIL_CONSENT_URL;
export const PAPI_V0_URL = import.meta.env.VITE_PAPI_V0_URL;

export type Brand = 'bikeleasing' | 'probonio';
export const BRAND = import.meta.env.VITE_BRAND as Brand;
export const IS_BIKELEASING = BRAND === 'bikeleasing';
export const USE_BLS_THEME = IS_BIKELEASING;

export const REDIRECT_KEY_STORAGE = 'next_page';
export const REDIRECT_KEY_QUERY = 'next';

const PROBONIO_UI_URL = import.meta.env.VITE_PROBONIO_UI_URL;
const BIKELEASING_PORTAL_URL = import.meta.env.VITE_BIKELEASING_PORTAL_URL;
export const APP_URL: UrlSchema = { bls: withForceKeycloak(BIKELEASING_PORTAL_URL), probonio: PROBONIO_UI_URL };

const BIKELEASING_BASE_URL = 'https://bikeleasing.de';
const PROBONIO_BASE_URL = 'https://probonio.de';

export const CONTACT_URL: UrlSchema = {
  bls: `${BIKELEASING_BASE_URL}/kontakt`,
  probonio: `${PROBONIO_BASE_URL}/kontakt/kontakt-aufnehmen`,
};

export const PRIVACY_URL: UrlSchema = 'https://files.bikeleasing.de/pdf/de/dsgvo-bikeleasing-de.pdf';

// 2 PX more to account for the 1 PX border of the paper component
export const DEFAULT_PAPER_WIDTH = 442;

export const AVAILABLE_COUNTRIES_REGISTRATION = [
  {
    value: 'DE',
    name: {
      en: 'Germany',
      de: 'Deutschland',
    },
    support: {
      phone: '+49 55 71 / 30 26 - 0',
      email: 'info@bikeleasing.de',
    },
  },
  {
    value: 'AT',
    name: {
      en: 'Austria',
      de: 'Österreich',
    },
    support: {
      phone: '+43 512 / 219 32 - 100',
      email: 'info@bikeleasing.at',
    },
  },
];

export const EMPLOYEE_EMAIL_EXISTS_ERROR = 'error:account@bikeleasing:employee-email-already-exists';
export const EMPLOYEE_NOT_ELIGIBLE_ERROR = 'error:account@bikeleasing:employee-not-eligible';
export const MISSING_REQUIRED_FIELD_ERROR = 'error:account@bikeleasing:missing-required-field';
export const REGISTRATION_CODE_EMPLOYEE_MISMATCH_ERROR = 'error:account@bikeleasing:registration-code-employee-mismatch';

export const FIELD_LABEL_EMPLOYEE_NUMBER_LH = 'app.registration_personal_number_label.lufthansa';

export const EXAMPLE_VALID_PHONE_NUMBER = () => {
  const country = getCurrentCountry();
  switch (country.value) {
    default:
    case 'DE':
      return '+49 123 987654321';
    case 'AT':
      return '+43 123 987654321';
  }
};

export const VAT_ID = 'DE460450663';
